"use client";

import { jsx as d, jsxs as $ } from "react/jsx-runtime";
import F, { useRef as G, useState as J, useEffect as j } from "react";
import { classNames as O } from "../../utilities/index.js";
import K from "../Icon/index.js";
import "./index.css.js";
const ie = _ref => {
    let {
      className: D,
      dotsClassName: E,
      arrowsClassName: Q,
      showDots: S,
      showArrows: U,
      prevIcon: X,
      nextIcon: Y,
      slidePadding: _ = 0,
      slidesToShow: g = {
        xs: 1
      },
      children: z,
      wrapperClassName: Z,
      showSlideCount: T,
      showSlideHints: L,
      allowOverflow: R,
      scrollTo: v,
      center: H = !0,
      prevButtonClass: ee,
      nextButtonClass: te,
      vertical: n = !1
    } = _ref;
    var B;
    const re = {
        xs: 0,
        sm: 550,
        md: 768,
        lg: 1024,
        xl: 1280,
        xxl: 1440,
        xxxl: 1900
      },
      C = (B = F.Children.toArray(z)) == null ? void 0 : B.length,
      e = G(null),
      k = G(null),
      [f, N] = J(0),
      [h, q] = J(0),
      m = n ? "offsetTop" : "offsetLeft";
    R != null && console.warn("This prop is deprecated and will be removed in the next major version of Sash. Please use `showSlideHints` instead.");
    const oe = O({
        "sash-Carousel snap-mandatory flex list-none m-0 p-0": !0,
        "sash-Carousel--hints scroll-px-6 px-6 md:scroll-px-8 md:px-8 xl:scroll-px-16 xl:px-16": L,
        "[&>li:last-child]:mr-auto [&>li:first-child]:ml-auto": !n && H,
        "[&>li:last-child]:mt-auto [&>li:first-child]:mb-auto": n && H,
        "overflow-x-auto snap-x flex-nowrap": !n,
        "overflow-y-auto snap-y flex-col": n,
        [D]: D
      }),
      se = O({
        "sash-CarouselDots flex flex-wrap justify-center list-none p-0 mb-0 mt-3 lg:mt-6 overflow-hidden": !0,
        [E]: E
      }),
      M = O({
        "sash-CarouselArrow absolute top-1/2 z-6 h-28 w-7 cursor-pointer items-center justify-center border border-black bg-white text-black shadow-md md:h-10 md:w-10": !0,
        "-mt-14 md:-mt-5": !S,
        "-translate-y-1/2 -mt-1 md:-mt-4": S
      }),
      ne = {
        "--slides-xs": g.xs,
        "--slides-sm": g.sm,
        "--slides-md": g.md,
        "--slides-lg": g.lg,
        "--slides-xl": g.xl,
        "--slides-xxl": g.xxl,
        "--slides-padding": `${_}px`
      };
    j(() => {
      var t, o;
      if (typeof v != "number" || !(e != null && e.current)) return;
      const r = ((t = e.current.childNodes[v]) == null ? void 0 : t[m]) - ((o = e.current.childNodes[0]) == null ? void 0 : o[m]);
      e.current.scroll({
        left: n ? 0 : r,
        top: n ? r : 0,
        behavior: "instant"
      }), setTimeout(() => N(v), 400);
    }, [v]), j(() => {
      k.current && h <= f && h > 0 && N(f - 1);
    }, [h, f]), j(() => {
      if ("IntersectionObserver" in window && e != null && e.current) {
        k.current || (k.current = !0, I());
        const r = {
            root: e.current,
            rootMargin: "0px",
            threshold: 0.5
          },
          t = e.current.childNodes,
          o = new IntersectionObserver(s => {
            var a, i;
            for (let l = 0; l < s.length; l++) {
              const c = Array.from(t).indexOf(s[l].target);
              if (!n && ((a = e.current) == null ? void 0 : a.scrollLeft) === 0 || n && ((i = e.current) == null ? void 0 : i.scrollTop) === 0) {
                N(0);
                break;
              } else if (s[l].intersectionRatio === 1) {
                W(c);
                break;
              } else if (s[l].isIntersecting) {
                N(u => c > u ? u + 1 : c > 0 && c < u ? u - 1 : 0), W(c);
                break;
              }
            }
          }, r);
        return t == null || t.forEach(s => o.observe(s)), window.addEventListener("resize", I), () => {
          o.disconnect(), window.removeEventListener("resize", I), k.current = !1;
        };
      }
    }, [e.current]);
    const I = () => {
        var o, s, a, i, l, c, u, p, x, b, w, y;
        const r = Object.entries(g).reduce((A, V) => window.innerWidth >= re[V[0]] ? V : A),
          t = C + 1 - Math.floor(r[1]);
        !n && ((o = e.current) == null ? void 0 : o.scrollWidth) <= ((s = e.current) == null ? void 0 : s.clientWidth) || n && ((a = e.current) == null ? void 0 : a.scrollHeight) <= ((i = e.current) == null ? void 0 : i.clientHeight) ? (q(0), (p = (u = (c = (l = e.current) == null ? void 0 : l.parentNode) == null ? void 0 : c.previousSibling) == null ? void 0 : u.classList) == null || p.add("hidden")) : (q(t, e.current), (y = (w = (b = (x = e.current) == null ? void 0 : x.parentNode) == null ? void 0 : b.previousSibling) == null ? void 0 : w.classList) == null || y.remove("hidden"), W(f));
      },
      le = r => {
        const t = e.current.childNodes,
          o = r === 0 ? 0 : t[r][m] - t[0][m];
        e.current.scroll({
          behavior: "smooth",
          left: n ? 0 : o,
          top: n ? o : 0
        });
      },
      P = r => {
        var s, a, i, l;
        const t = e.current.childNodes;
        let o = 0;
        r === "next" ? o = ((s = t == null ? void 0 : t[f + 1]) == null ? void 0 : s[m]) - ((a = t == null ? void 0 : t[0]) == null ? void 0 : a[m]) : o = ((i = t == null ? void 0 : t[f - 1]) == null ? void 0 : i[m]) - ((l = t == null ? void 0 : t[0]) == null ? void 0 : l[m]), e.current.scroll({
          behavior: "smooth",
          left: n ? 0 : o,
          top: n ? o : 0
        });
      },
      ae = r => {
        var t, o, s, a, i, l, c, u, p, x, b;
        r.preventDefault(), (t = r.target.parentNode) != null && t.nextSibling ? ((s = (o = r.target.parentNode) == null ? void 0 : o.nextSibling) == null || s.setAttribute("tabindex", "0"), (i = (a = r.target.parentNode) == null ? void 0 : a.nextSibling) == null || i.focus()) : ((u = (c = (l = r.target.parentNode) == null ? void 0 : l.parentNode) == null ? void 0 : c.nextSibling) == null || u.setAttribute("tabindex", "0"), (b = (x = (p = r.target.parentNode) == null ? void 0 : p.parentNode) == null ? void 0 : x.nextSibling) == null || b.focus());
      },
      W = r => {
        var t, o, s, a, i, l, c, u, p, x, b, w, y, A;
        r >= C - 1 || !n && ((t = e == null ? void 0 : e.current) == null ? void 0 : t.scrollLeft) >= ((o = e == null ? void 0 : e.current) == null ? void 0 : o.scrollWidth) - ((s = e == null ? void 0 : e.current) == null ? void 0 : s.clientWidth) || n && ((a = e == null ? void 0 : e.current) == null ? void 0 : a.scrollTop) >= ((i = e == null ? void 0 : e.current) == null ? void 0 : i.scrollHeight) - ((l = e == null ? void 0 : e.current) == null ? void 0 : l.clientHeight) ? (f !== h && N(h), (x = (p = (u = (c = e.current) == null ? void 0 : c.parentNode) == null ? void 0 : u.previousSibling) == null ? void 0 : p.querySelector(".sash-CarouselArrows-Next")) == null || x.classList.add("!hidden")) : (A = (y = (w = (b = e.current) == null ? void 0 : b.parentNode) == null ? void 0 : w.previousSibling) == null ? void 0 : y.querySelector(".sash-CarouselArrows-Next")) == null || A.classList.remove("!hidden");
      };
    return C === 0 ? /* @__PURE__ */d("p", {
      children: "No slides to display"
    }) : /* @__PURE__ */$("div", {
      className: `sash-CarouselWrapper relative ${Z || ""}`,
      style: {
        ...ne
      },
      children: [/* @__PURE__ */d("button", {
        onClick: ae,
        className: "sr-only left-0 top-0 bg-white focus:not-sr-only focus:!fixed focus:!p-4",
        children: "Skip Carousel"
      }), U && C > 1 && /* @__PURE__ */$("ul", {
        className: `sash-CarouselArrows m-0 hidden list-none p-0 ${Q || ""}`,
        "data-testid": "carousel-arrows",
        children: [/* @__PURE__ */d("li", {
          children: /* @__PURE__ */d("button", {
            className: `${M} sash-CarouselArrows-Previous ${f === 0 ? "hidden" : "flex"} ${L ? "left-2" : "-left-3 md:-left-5"} ${ee || ""}`,
            onClick: () => P("previous"),
            "aria-label": "Previous",
            children: X || /* @__PURE__ */d(K, {
              name: "arrow_left"
            })
          })
        }), /* @__PURE__ */d("li", {
          children: /* @__PURE__ */d("button", {
            className: `${M} sash-CarouselArrows-Next flex ${L ? "right-2" : "-right-3 md:-right-5"} ${te || ""}`,
            onClick: () => P("next"),
            "aria-label": "Next",
            children: Y || /* @__PURE__ */d(K, {
              name: "arrow_right"
            })
          })
        })]
      }), C > 0 && /* @__PURE__ */d("div", {
        className: "overflow-hidden",
        children: /* @__PURE__ */d("ul", {
          ref: e,
          className: oe,
          style: {
            gap: _
          },
          tabIndex: 0,
          "data-testid": "carousel",
          children: F.Children.toArray(z).map((r, t) => /* @__PURE__ */d("li", {
            className: `sash-CarouselSlide min-w-0 max-w-full snap-start ${f === t ? "sash-CarouselSlide--active" : ""}`,
            children: r
          }, t))
        })
      }), T && h > 1 && /* @__PURE__ */$("p", {
        className: "sash-CarouselCount my-5 text-center text-sm text-gray-60",
        children: ["Slide ", f + 1, " / ", h]
      }), S && h > 1 && C > 1 && /* @__PURE__ */d("ul", {
        className: se,
        "data-testid": "carousel-dots",
        children: [...Array(h)].map((r, t) => /* @__PURE__ */d("li", {
          "data-index": t,
          className: "mt-2 flex-initial px-0.5 leading-none",
          children: /* @__PURE__ */$("button", {
            className: `sash-CarouselDot relative block h-4 w-8 cursor-pointer -indent-[9999rem] before:absolute before:left-0 before:top-1/2 before:-mt-px before:h-0.5 before:w-full before:content-[""] ${f === t ? "before:bg-black" : "before:bg-gray-15 hover:before:bg-gray-30"}`,
            onClick: () => le(t),
            "aria-current": f === t ? "true" : "false",
            children: ["Slide #", t]
          })
        }, t))
      })]
    });
  },
  me = ie;
export { me as default };